/**
 * Application entry point.
 *
 * Validates environment variables, initializes third-party scripts,
 * and mounts the React app into #root.
 *
 * @spec SPEC:ENGINEERING:FRONTEND:CORE
 */

// Environment validation runs first — fails fast if misconfigured
import './env'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { scriptManager } from '@/services/scripts'
import '@/styles/globals.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found in DOM')

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
)

// Load third-party scripts after app mount — never block first paint
void scriptManager.init()
